import React from "react";

export default function Myths() {
	return (
		<>
			<h2>Myths to avoid</h2>
			<section className="subHeader">
			</section>
		</>
	);
}
